/* eslint-disable prefer-destructuring */
/* eslint-disable no-plusplus */
/* eslint-disable no-underscore-dangle */
/* eslint-disable eqeqeq */
import moment from 'moment';
import { compareAsc } from 'date-fns';
import { CITY_OPTIONS } from './Constants/CitiesFrom';
import {
  initDepartureDate,
  initalDepartureCity,
  initalDepartureHotel,
  initialDestinationCountry,
  initialNightsFrom,
  initialNightsTo,
  initialAdultsCount,
  initialKids,
  initialCurrency,
} from './Constants/InitialStateUtils';
import { TOUR_TYPE } from './Constants/SearchType';
import {
  getCountryById,
  getHotelById,
  getResortsByCountryId,
  getResortsByCountryIdAndThen,
} from './ElasticUtils';
import {
  TOUR_SEARCH_REGIONS_INDEX,
  TOUR_SEARCH_HOTELS_INDEX,
} from './Constants/Indexes';

import {
  BEFORE_YEAR,
  ONE_YEAR,
  TWO_YEARS,
  THREE_YEARS,
  FOUR_YEARS,
  FIVE_YEARS,
  SIX_YEARS,
  SEVEN_YEARS,
  EIGHT_YEARS,
  NINE_YEARS,
  TEN_YEARS,
  ELEVEN_YEARS,
  TWELVE_YEARS,
  THIRTEEN_YEARS,
  FOURTEEN_YEARS,
  FIFTEEN_YEARS,
  SIXTEEN_YEARS,
  SEVENTEEN_YEARS,
} from './Constants/HomePageConstants';
import {
  ORDER_WAIT_PAYMENT_STATUS,
  ORDER_WAIT_PAIMENT,
  ORDER_WAIT_APPROVAL_STATUS,
  ORDER_WAIT_APPROVAL,
  ORDER_APPROVED_STATUS,
  ORDER_APPROVED,
  ORDER_DECLINED_STATUS,
  ORDER_DECLINED,
} from './Constants/GlobalConstants';

import {
  FROM_PARAM,
  TO_PARAM,
  DEPARTURE_FROM_PARAM,
  DEPARTURE_TO_PARAM,
  NIGHTS_FROM_PARAM,
  NIGHTS_TO_PARAM,
  ADULTS_PARAM,
  CURRENCY_PARAM,
  KIDS_AGES_PARAM,
  HOTEL_PARAM,
  HOTELS_PARAM,
  STARS_PARAM,
  RATING_PARAM,
  MEALS_PARAM,
  BEACH_LINE_PARAM,
  BEACH_TYPE_PARAM,
  HOTEL_TYPE_PARAM,
  OPERATORS_PARAM,
  SERVICES_PARAM,
  REGION_PARAM,
  SUBREGION_PARAM,
  CHARTER_ONLY_PARAM,
  DIRECT_PARAM,
  // MIN_PRICE_PARAM,
  // MAX_PRICE_PARAM,
  HOME_PAGE,
  TOUR_ID,
} from './Constants/urlParams';
import { meals } from './Constants/Meals';
import { beachTypes } from './Constants/BeachTypes';
import { hotelTypeOptions } from './Constants/HotelTypes';
import { services } from './Constants/Services';
import { availableCurrencies } from './Constants/Currency';
import { operators } from './Constants/Operators';
import { countries } from './Constants/countries';
import {
  ORDER_STAGES,
  STAGE_ORDER_CREATED,
  STAGE_APPROVED,
} from './Constants/AdminConstants';

export const getKidsText = (age) => {
  let result = '';

  switch (age) {
    case 0:
      result = BEFORE_YEAR;
      break;
    case 1:
      result = ONE_YEAR;
      break;
    case 2:
      result = TWO_YEARS;
      break;
    case 3:
      result = THREE_YEARS;
      break;
    case 4:
      result = FOUR_YEARS;
      break;
    case 5:
      result = FIVE_YEARS;
      break;
    case 6:
      result = SIX_YEARS;
      break;
    case 7:
      result = SEVEN_YEARS;
      break;
    case 8:
      result = EIGHT_YEARS;
      break;
    case 9:
      result = NINE_YEARS;
      break;
    case 10:
      result = TEN_YEARS;
      break;
    case 11:
      result = ELEVEN_YEARS;
      break;
    case 12:
      result = TWELVE_YEARS;
      break;
    case 13:
      result = THIRTEEN_YEARS;
      break;
    case 14:
      result = FOURTEEN_YEARS;
      break;
    case 15:
      result = FIFTEEN_YEARS;
      break;
    case 16:
      result = SIXTEEN_YEARS;
      break;
    case 17:
      result = SEVENTEEN_YEARS;
      break;
    default:
      break;
  }

  return result;
};

export const getTouristsText = (adults, kids) => {
  let result = '';

  if (adults) {
    // eslint-disable-next-line eqeqeq
    if (adults == 1) {
      result = '1 взрослый';
    } else {
      result = `${adults} взрослых`;
    }
  }

  if (kids) {
    // eslint-disable-next-line eqeqeq
    if (kids == 1) {
      result += ', 1 ребенок';
    } else if (kids > 1) {
      result += `, ${kids} детей`;
    }
  }

  return result;
};

export const getDateAndNightsText = (priceData) => {
  let result = `с ${priceData.departureDate} на`;

  if (priceData.nightsCount === 1) {
    result = `${result} 1 ночь`;
  } else if (priceData.nightsCount < 5) {
    result = `${result} ${priceData.nightsCount} ночи`;
  } else {
    result = `${result} ${priceData.nightsCount} ночей`;
  }

  return result;
};

export const getOrderStatusText = (status) => {
  let result = '';

  if (status === ORDER_WAIT_PAYMENT_STATUS) {
    result = ORDER_WAIT_PAIMENT;
  } else if (status === ORDER_WAIT_APPROVAL_STATUS) {
    result = ORDER_WAIT_APPROVAL;
  } else if (status === ORDER_APPROVED_STATUS) {
    result = ORDER_APPROVED;
  } else if (status === ORDER_DECLINED_STATUS) {
    result = ORDER_DECLINED;
  }

  return result;
};

// Orders created before stages were introduced have no stage yet
export const getOrderStage = (order) => {
  if (order.stage) {
    return order.stage;
  }

  return order.status === ORDER_APPROVED_STATUS
    ? STAGE_APPROVED
    : STAGE_ORDER_CREATED;
};

export const getOrderStageData = (order) => {
  const stageId = getOrderStage(order);
  const stage = ORDER_STAGES.find((item) => item.id === stageId);
  return stage || { id: stageId, title: stageId, color: '#D4D9DE' };
};

export const getOrderStageTitle = (order) => getOrderStageData(order).title;

export function getSelectedRegionsAndSubregions(regions) {
  const result = [];

  regions.forEach((region) => {
    if (region.checked) {
      const sub = region.subregions;

      if (!sub || sub.length === sub.filter((i) => i.checked).length) {
        result.push(region);
      } else {
        sub.forEach((subRegion) => {
          if (subRegion.checked) {
            result.push(subRegion);
          }
        });
      }
    }
  });

  return result;
}

export function listOfObjectsWithIdToString(list) {
  let result = '';

  list.forEach((item) => {
    if (result.length != 0) {
      result += ',';
    }

    result += item.id;
  });

  return result;
}

export function arrayToString(array) {
  let result = '';

  array.forEach((item) => {
    if (result.length !== 0) {
      result += ',';
    }

    result += item;
  });

  return result;
}

export function getInitialSearchUrlObj(props, fromHotelPage) {
  const {
    depatureCity,
    destination,
    departureDate,
    nightsFrom,
    nightsTo,
    adults,
    kids,
    selectedResorts,
    currency,
    hotelsFilter,
  } = props;

  const queryParameters = new URLSearchParams();

  queryParameters.append(FROM_PARAM, depatureCity.id);
  queryParameters.append(TO_PARAM, destination.id);
  queryParameters.append(
    DEPARTURE_FROM_PARAM,
    departureDate.from ? moment(departureDate.from).format('YYYY-MM-DD') : '',
  );
  queryParameters.append(
    DEPARTURE_TO_PARAM,
    departureDate.to ? moment(departureDate.to).format('YYYY-MM-DD') : '',
  );
  queryParameters.append(NIGHTS_FROM_PARAM, nightsFrom);
  queryParameters.append(NIGHTS_TO_PARAM, nightsTo);
  queryParameters.append(ADULTS_PARAM, adults);
  queryParameters.append(CURRENCY_PARAM, currency.id);

  if (kids.length > 0) {
    queryParameters.append(
      KIDS_AGES_PARAM,
      arrayToString(kids.map((item) => item.age)),
    );
  }

  if (fromHotelPage && hotelsFilter.length === 1) {
    queryParameters.append(
      HOTEL_PARAM,
      listOfObjectsWithIdToString(hotelsFilter),
    );
  } else {
    const selectedRegions = getSelectedRegionsAndSubregions(selectedResorts);

    if (selectedRegions.length > 0) {
      const regions = selectedRegions.filter((e) => e.type === 'region');
      const subregions = selectedRegions.filter((e) => e.type === 'subregion');

      if (regions.length > 0) {
        queryParameters.append(
          REGION_PARAM,
          listOfObjectsWithIdToString(regions),
        );
      }

      if (subregions.length > 0) {
        queryParameters.append(
          SUBREGION_PARAM,
          listOfObjectsWithIdToString(subregions),
        );
      }
    }

    if (hotelsFilter.length > 0) {
      queryParameters.append(
        HOTELS_PARAM,
        listOfObjectsWithIdToString(hotelsFilter),
      );
    }
  }

  return queryParameters;
}

export function getInitialSearchUrl(props, fromHotelPage) {
  return getInitialSearchUrlObj(props, fromHotelPage).toString();
}

export function getMonth(date) {
  let mounth;
  switch (date.getMonth()) {
    case 0:
      mounth = 'янв.';
      break;
    case 1:
      mounth = 'фев.';
      break;
    case 2:
      mounth = 'март';
      break;
    case 3:
      mounth = 'апр.';
      break;
    case 4:
      mounth = 'май';
      break;
    case 5:
      mounth = 'июн.';
      break;
    case 6:
      mounth = 'июл.';
      break;
    case 7:
      mounth = 'авг.';
      break;
    case 8:
      mounth = 'сен.';
      break;
    case 9:
      mounth = 'окт.';
      break;
    case 10:
      mounth = 'ноя.';
      break;
    case 11:
      mounth = 'дек.';
      break;

    default:
      break;
  }

  return mounth;
}

export function getDateText(date) {
  let result;

  if (date.from && date.to) {
    if (date.from.getMonth() === date.to.getMonth()) {
      if (date.from.getDate() === date.to.getDate()) {
        result = `${date.from.getDate()} ${getMonth(
          date.from,
        )} ${date.from.getFullYear()}`;
      } else {
        result = `${date.from.getDate()} - ${date.to.getDate()} ${getMonth(
          date.from,
        )} ${date.to.getFullYear()}`;
      }
    } else {
      result = `${date.from.getDate()} ${getMonth(
        date.from,
      )} - ${date.to.getDate()} ${getMonth(date.to)} ${date.to.getFullYear()}`;
    }
  } else if (date.from && !date.to) {
    result = `с ${date.from.getDate()} ${getMonth(date.from)}`;
  }

  return result;
}

export function getNightsText(nightsFrom, nightsTo) {
  if (nightsFrom && !nightsTo) {
    return `${nightsFrom} ночей`;
  } else if (nightsFrom === nightsTo) {
    return `${nightsFrom} ночей`;
  } else {
    return `${nightsFrom} - ${nightsTo} ночей`;
  }
}

export function getNightsTextNoRange(nights) {
  let result = '';
  if (nights) {
    if (nights === 1) {
      result = '1 ночь';
    } else if (nights < 5) {
      result = `${nights} ночи`;
    } else {
      result = `${nights} ночей`;
    }
  }

  return result;
}

export function getDayText(stringDate) {
  const date = moment(stringDate, 'DD.MM.YYYY').toDate();

  return `${date.getDate()} ${getMonth(date)} ${date.getFullYear()}`;
}

function isNumberParamValid(param) {
  return param && param.length > 0 && !Number.isNaN(parseInt(param, 10));
}

export function setInitalSearchState(props, searchType) {
  const {
    changeDepatureCity,
    changeDestination,
    changeDepartureDate,
    setNightsFrom,
    setNightsTo,
    // changeSelectedResorts,
    setAdults,
    setKids,
    // changeResortsCountry,
    // changeSearchType,
    // changeHotelsFilter,
  } = props;

  if (searchType === TOUR_TYPE) {
    changeDepatureCity(initalDepartureCity);
    changeDestination(initialDestinationCountry);
  } else {
    changeDepatureCity(initalDepartureHotel);
    changeDestination({});
  }

  changeDepartureDate(initDepartureDate());
  setNightsFrom(initialNightsFrom);
  setNightsTo(initialNightsTo);
  // changeSelectedResorts([]);
  setAdults(initialAdultsCount);
  setKids(initialKids);
  // changeResortsCountry(initialResortsCountry);
  // changeSearchType(searchType);
  // changeHotelsFilter([]);
}

export function goHomeAndStateReset(props) {
  setInitalSearchState(props, TOUR_TYPE);
  window.location.replace(HOME_PAGE);
}

function formatDate(value) {
  let result = null;
  const date = value.split('-');

  if (
    date.length === 3 &&
    !Number.isNaN(date[0]) &&
    !Number.isNaN(date[1]) &&
    !Number.isNaN(date[2])
  ) {
    const y = parseInt(date[0], 10);
    const m = parseInt(date[1], 10);
    const d = parseInt(date[2], 10);

    result = new Date(y, m - 1, d);
  }

  return result;
}

export function compareName(a, b) {
  const nameA = a.name.toUpperCase();
  const nameB = b.name.toUpperCase();

  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }

  return 0;
}

export function updateStateFromUrl(props) {
  const {
    location,
    depatureCity,
    changeDepatureCity,
    destination,
    changeDestination,
    departureDate,
    changeDepartureDate,
    setNightsFrom,
    setNightsTo,
    adults,
    setAdults,
    kids,
    setKids,
    changeHotelsFilter,
    hotelsFilter,
    changeStarsFilter,
    changeStarsFilterHover,
    changeMealsFilter,
    changeRatingFilter,
    changeBeachLineFilter,
    changeBeachTypesFilter,
    changeHotelTypeFilter,
    changeHotelServicesFilter,
    changeOnlyCharter,
    changeDirectFlight,
    changeCurrency,
    changeSelectedResorts,
    changeIsAllRegionsFilterTab,
    changeRegionsOptions,
    changeOperatorsFilter,
    changeIsAllOperatorsTab,
    changeSelectedHotels,
    changeTouristsSearchText,
    changeDatesSearchText,

    // changeMinPriceFilter,
    // changeMaxPriceFilter,
  } = props;

  const queryParameters = new URLSearchParams(location.search);

  const payload = {};

  if (
    queryParameters &&
    isNumberParamValid(queryParameters.get(FROM_PARAM)) &&
    isNumberParamValid(queryParameters.get(TO_PARAM)) &&
    isNumberParamValid(queryParameters.get(NIGHTS_FROM_PARAM)) &&
    isNumberParamValid(queryParameters.get(NIGHTS_TO_PARAM)) &&
    isNumberParamValid(queryParameters.get(ADULTS_PARAM))
  ) {
    // from
    const fromPayload = queryParameters.get(FROM_PARAM);
    payload[FROM_PARAM] = fromPayload;

    if (fromPayload != depatureCity.id) {
      const filteredCities = CITY_OPTIONS.filter(
        (city) => city.id == fromPayload,
      );

      if (filteredCities.length > 0) {
        changeDepatureCity(filteredCities[0]);
      } else {
        goHomeAndStateReset(props);
      }
    }

    // to
    const toPayload = queryParameters.get(TO_PARAM);
    payload[TO_PARAM] = toPayload;

    if (toPayload != destination.id) {
      let destinationCountry;
      getCountryById(toPayload, TOUR_SEARCH_REGIONS_INDEX).then((result) => {
        destinationCountry = result.data.hits.hits.map((h) => h._source);
        if (destinationCountry && destinationCountry.length > 0) {
          changeDestination(destinationCountry[0]);
        } else {
          goHomeAndStateReset(props);
        }
      });
    }

    // date
    let departDate = departureDate;
    if (queryParameters.get(DEPARTURE_FROM_PARAM)) {
      const departureFromPayload = queryParameters.get(DEPARTURE_FROM_PARAM);
      const departureToPayload = queryParameters.get(DEPARTURE_TO_PARAM)
        ? queryParameters.get(DEPARTURE_TO_PARAM)
        : queryParameters.get(DEPARTURE_FROM_PARAM);

      const dateFromPayload = formatDate(departureFromPayload);
      const dateToPayload = formatDate(departureToPayload);

      payload[DEPARTURE_FROM_PARAM] =
        moment(dateFromPayload).format('YYYY-MM-DD');
      payload[DEPARTURE_TO_PARAM] = moment(dateToPayload).format('YYYY-MM-DD');

      if (
        !dateFromPayload ||
        !dateToPayload ||
        compareAsc(dateFromPayload, dateToPayload) == 1
      ) {
        goHomeAndStateReset(props);
        return;
      }

      if (
        compareAsc(departureDate.from, dateFromPayload) != 0 ||
        compareAsc(departureDate.to, dateToPayload) != 0
      ) {
        departDate = { from: dateFromPayload, to: dateToPayload };
        changeDepartureDate(departDate);
      }
    } else {
      payload[DEPARTURE_FROM_PARAM] = moment(departureDate.from).format(
        'YYYY-MM-DD',
      );
      payload[DEPARTURE_TO_PARAM] = moment(departureDate.to).format(
        'YYYY-MM-DD',
      );
    }

    // nights
    const nightsFromPayload = queryParameters.get(NIGHTS_FROM_PARAM);
    const nightsToPayload = queryParameters.get(NIGHTS_TO_PARAM)
      ? queryParameters.get(NIGHTS_TO_PARAM)
      : queryParameters.get(NIGHTS_FROM_PARAM);
    let nf;
    let nt;
    if (!Number.isNaN(nightsFromPayload) && !Number.isNaN(nightsToPayload)) {
      nf = parseInt(nightsFromPayload, 10);
      nt = parseInt(nightsToPayload, 10);
    }
    if (nf > nt) {
      nf = 7;
      nt = 9;
    }
    setNightsFrom(nf);
    setNightsTo(nt);
    payload[NIGHTS_FROM_PARAM] = nf;
    payload[NIGHTS_TO_PARAM] = nt;

    // adults
    const adultsPayload = parseInt(queryParameters.get(ADULTS_PARAM), 10);
    if (adults != adultsPayload) {
      let adRes;
      if (adultsPayload <= 4) {
        adRes = adultsPayload;
      } else {
        adRes = 2;
      }
      setAdults(adRes);
    }

    payload[ADULTS_PARAM] = adultsPayload;

    // kids
    const kidsAgesPayload = queryParameters.get(KIDS_AGES_PARAM)
      ? queryParameters.get(KIDS_AGES_PARAM)
      : '';

    payload[KIDS_AGES_PARAM] = kidsAgesPayload;

    let kidsNewState = [];
    if (kidsAgesPayload !== '') {
      const kidsAges = kidsAgesPayload.split(',');

      if (kidsAges.length != kids.length) {
        for (let i = 0; i < kidsAges.length; i++) {
          if (!Number.isNaN(kidsAges[i])) {
            const age = parseInt(kidsAges[i], 10);
            if (kidsNewState.length < 3) {
              const index = Math.floor(Math.random() * 1000);
              const kid = { age, text: getKidsText(age), index };
              kidsNewState = kidsNewState.concat([kid]);
            }
          } else {
            goHomeAndStateReset(props);
            return;
          }
        }
      } else {
        goHomeAndStateReset(props);
        return;
      }

      setKids(kidsNewState);
    }

    // hotels
    const hotelsPayload = queryParameters.get(HOTELS_PARAM)
      ? queryParameters.get(HOTELS_PARAM).split(',')
      : [];

    payload[HOTELS_PARAM] = queryParameters.get(HOTELS_PARAM);

    const hotels = [];

    for (let i = 0; i < hotelsPayload.length; i++) {
      const id = hotelsPayload[i];
      // eslint-disable-next-line no-loop-func
      if (!Number.isNaN(id)) {
        getHotelById(id, TOUR_SEARCH_HOTELS_INDEX).then((response) => {
          const hotelsresult = response.data.hits.hits.map((h) => h._source);
          if (hotelsresult.length > 0) {
            const hotel = hotelsresult[0];
            hotel.checked = true;
            hotels.push(hotel);

            const hotelRes = hotelsFilter.concat(hotels);
            changeHotelsFilter(hotelRes);
            changeSelectedHotels(hotelRes);
          }
        });
      }
    }

    // hotel
    const hotelPayload = queryParameters.get(HOTEL_PARAM)
      ? queryParameters.get(HOTEL_PARAM)
      : '';

    payload[HOTEL_PARAM] = hotelPayload;
    if (!Number.isNaN(hotelPayload)) {
      getHotelById(hotelPayload, TOUR_SEARCH_HOTELS_INDEX).then((response) => {
        const hotelsresult = response.data.hits.hits.map((h) => h._source);
        if (hotelsresult.length > 0) {
          const hotel = hotelsresult[0];
          if (hotel) {
            hotel.checked = true;
            changeHotelsFilter([hotel]);
          }
        }
      });
    }

    // stars
    const starsPayload = !Number.isNaN(queryParameters.get(STARS_PARAM))
      ? queryParameters.get(STARS_PARAM)
      : null;

    if (starsPayload) {
      payload[STARS_PARAM] = starsPayload;
      changeStarsFilter(parseInt(starsPayload, 10));
      changeStarsFilterHover(parseInt(starsPayload, 10));
    }

    // meal
    const mealId = queryParameters.get(MEALS_PARAM)
      ? queryParameters.get(MEALS_PARAM)
      : null;

    let mealPayload;

    if (mealId) {
      const filteredMeal = meals.filter((e) => e.id == mealId);
      if (filteredMeal.length > 0) {
        mealPayload = filteredMeal[0];
      }
    }
    if (mealPayload) {
      changeMealsFilter(mealPayload);
      payload[MEALS_PARAM] = mealPayload.id;
    }

    // rating
    const ratingPayload = !Number.isNaN(queryParameters.get(RATING_PARAM))
      ? queryParameters.get(RATING_PARAM)
      : null;

    if (ratingPayload) {
      payload[RATING_PARAM] = ratingPayload;
      changeRatingFilter(parseInt(ratingPayload, 10));
    }

    // beachLine
    const beachLinePayload = !Number.isNaN(
      queryParameters.get(BEACH_LINE_PARAM),
    )
      ? queryParameters.get(BEACH_LINE_PARAM)
      : null;
    if (beachLinePayload) {
      const line = parseInt(beachLinePayload, 10);
      changeBeachLineFilter(line);
      payload[BEACH_LINE_PARAM] = line;
    }

    // beach type
    const beachTypeArray = queryParameters.get(BEACH_TYPE_PARAM)
      ? queryParameters.get(BEACH_TYPE_PARAM).split(',')
      : null;

    const beachTypePayload = [];
    if (beachTypeArray) {
      beachTypeArray.forEach((item) => {
        const filteredBeachTypes = beachTypes.filter(
          (e) => e.id === parseInt(item, 10),
        );
        if (filteredBeachTypes.length > 0) {
          beachTypePayload.push(filteredBeachTypes[0]);
        }
      });
    }
    if (beachTypePayload.length > 0) {
      changeBeachTypesFilter(beachTypePayload);
      payload[BEACH_TYPE_PARAM] = listOfObjectsWithIdToString(beachTypePayload);
    }

    // hotel type
    const hotelTypeArray = queryParameters.get(HOTEL_TYPE_PARAM)
      ? queryParameters.get(HOTEL_TYPE_PARAM).split(',')
      : null;

    const hotelTypePayload = [];
    if (hotelTypeArray) {
      hotelTypeArray.forEach((item) => {
        const filteredHotelTypes = hotelTypeOptions.filter((e) => {
          if (e.id == item) {
            return true;
          }

          return false;
        });

        if (filteredHotelTypes.length > 0) {
          hotelTypePayload.push(filteredHotelTypes[0]);
        }
      });
    }

    if (hotelTypePayload.length > 0) {
      changeHotelTypeFilter(hotelTypePayload);
      payload[HOTEL_TYPE_PARAM] = listOfObjectsWithIdToString(hotelTypePayload);
    }

    // hotel services
    const hotelServicesArray = queryParameters.get(SERVICES_PARAM)
      ? queryParameters.get(SERVICES_PARAM).split(',')
      : null;

    const hotelServicesPayload = [];
    if (hotelServicesArray) {
      hotelServicesArray.forEach((item) => {
        const filteredHotelServices = services.filter((e) => e.id == item);
        if (filteredHotelServices.length > 0) {
          hotelServicesPayload.push(filteredHotelServices[0]);
        }
      });
    }

    if (hotelServicesPayload.length > 0) {
      changeHotelServicesFilter(hotelServicesPayload);
      payload[SERVICES_PARAM] =
        listOfObjectsWithIdToString(hotelServicesPayload);
    }

    // charter
    const charterUrlParam = queryParameters.get(CHARTER_ONLY_PARAM)
      ? queryParameters.get(CHARTER_ONLY_PARAM)
      : null;
    if (charterUrlParam && charterUrlParam == 1) {
      changeOnlyCharter(1);
      payload[CHARTER_ONLY_PARAM] = charterUrlParam;
    } else {
      // keep state in sync with url (initial state is charter only)
      changeOnlyCharter(0);
    }

    // direct
    const directUrlParam = queryParameters.get(DIRECT_PARAM)
      ? queryParameters.get(DIRECT_PARAM)
      : null;
    if (directUrlParam && directUrlParam == 1) {
      changeDirectFlight(1);
      payload[DIRECT_PARAM] = directUrlParam;
    }

    // currency
    const currencyUrlParam = queryParameters.get(CURRENCY_PARAM)
      ? queryParameters.get(CURRENCY_PARAM)
      : null;
    if (currencyUrlParam) {
      const filteredCurrency = availableCurrencies.filter(
        (e) => e.id == currencyUrlParam,
      );
      if (filteredCurrency.length > 0) {
        changeCurrency(filteredCurrency[0]);
        payload[CURRENCY_PARAM] = filteredCurrency[0].id;
      } else {
        changeCurrency(initialCurrency);
        payload[CURRENCY_PARAM] = initialCurrency.id;
      }
    }

    // region
    const regionArr = queryParameters.get(REGION_PARAM)
      ? queryParameters.get(REGION_PARAM).split(',')
      : null;

    const subregionArr = queryParameters.get(SUBREGION_PARAM)
      ? queryParameters.get(SUBREGION_PARAM).split(',')
      : null;

    if (regionArr && regionArr.length > 0) {
      payload[REGION_PARAM] = queryParameters.get(REGION_PARAM);
    }

    if (subregionArr && subregionArr.length > 0) {
      payload[SUBREGION_PARAM] = queryParameters.get(SUBREGION_PARAM);
    }

    if (regionArr || subregionArr) {
      // get all resorts
      getResortsByCountryId(toPayload, TOUR_SEARCH_REGIONS_INDEX).then(
        (response) => {
          const { hits } = response.data;
          if (hits) {
            const resource = hits.hits.map((h) => h._source);
            const allRegions = resource
              .filter((item) => item.type === 'region')
              .map((item) => ({
                ...item,
                checked: false,
                subregions: resource
                  .filter((e) => e.parentregionId === item.id)
                  .map((sub) => ({ ...sub, checked: false }))
                  .sort(compareName),
                subregionsVisible: false,
              }));

            // prepare selecetd resorts
            const regions = [];
            if (regionArr) {
              regionArr.forEach((e) => {
                const filteredRegions = allRegions.filter((i) => i.id == e);
                if (filteredRegions.length > 0) {
                  const reg = filteredRegions[0];
                  reg.checked = true;
                  let sub = reg.subregions;
                  if (sub && sub.length > 0) {
                    sub = sub.map((i) => ({ ...i, checked: true }));
                    reg.subregions = sub;
                  }
                  regions.push(reg);
                }
              });
            }

            let subregions = [];
            if (subregionArr) {
              subregionArr.forEach((subregionId) => {
                allRegions.forEach((reg) => {
                  const subregs = reg.subregions;
                  if (subregs && subregs.length > 0) {
                    subregs.forEach((subreg) => {
                      if (subreg.id === subregionId) {
                        if (
                          subregions.filter((j) => j.id === reg.id).length === 0
                        ) {
                          subregions.push(reg);
                        }
                      }
                    });
                  }
                });
              });

              subregions = subregions.map((e) => {
                let subArray = e.subregions;
                if (subArray) {
                  subArray = subArray.map((k) => {
                    if (subregionArr.filter((i) => i === k.id).length > 0) {
                      return {
                        ...k,
                        checked: true,
                      };
                    }
                    return k;
                  });
                }
                return {
                  ...e,
                  checked: true,
                  subregions: subArray,
                };
              });
            }

            const selectedRes = regions.concat(subregions);
            changeSelectedResorts(selectedRes);

            // apply selected resorts on resorts options
            let resutltMapedToState = allRegions;

            selectedRes.forEach((selected) => {
              resutltMapedToState = resutltMapedToState.map((reg) => {
                if (reg.id === selected.id) {
                  const selectedSubr = selected.subregions;
                  let sub = reg.subregions;

                  if (selectedSubr) {
                    sub = sub.map((e) => {
                      const sel = selectedSubr.filter((i) => i.id === e.id);
                      if (sel.length > 0 && sel[0].checked) {
                        return {
                          ...e,
                          checked: true,
                        };
                      }

                      return e;
                    });
                  } else {
                    sub = sub.map((e) => ({
                      ...e,
                      checked: true,
                    }));
                  }

                  return {
                    ...reg,
                    checked: true,
                    subregions: sub,
                    subregionsVisible:
                      sub.length !==
                      sub.filter((e) => e.checked === true).length,
                  };
                }

                return reg;
              });
            });

            changeIsAllRegionsFilterTab(false);
            changeRegionsOptions(resutltMapedToState);
          }
        },
      );
    } else {
      getResortsByCountryIdAndThen(props, toPayload);
    }

    // operator
    const operatorArray = queryParameters.get(OPERATORS_PARAM)
      ? queryParameters.get(OPERATORS_PARAM).split(',')
      : null;
    const operatorPayload = [];
    if (operatorArray) {
      operatorArray.forEach((item) => {
        const filteredOperators = operators.filter((e) => e.id == item);
        if (filteredOperators.length > 0) {
          operatorPayload.push(filteredOperators[0]);
        }
      });
    }
    if (operatorPayload.length > 0) {
      changeOperatorsFilter(operatorPayload);
      changeIsAllOperatorsTab(false);
      payload[OPERATORS_PARAM] = listOfObjectsWithIdToString(operatorPayload);
    }

    //   // min price
    //   const minPriceUrlParam = params[MIN_PRICE_PARAM]
    //     ? params[MIN_PRICE_PARAM]
    //     : null;
    //   if (minPriceUrlParam && !isNaN(minPriceUrlParam)) {
    //     const minPrice = parseInt(minPriceUrlParam, 10);
    //     changeMinPriceFilter(minPrice);
    //     payload[MIN_PRICE_PARAM] = minPrice;
    //   }
    //   // max price
    //   const maxPriceUrlParam = params[MAX_PRICE_PARAM]
    //     ? params[MAX_PRICE_PARAM]
    //     : null;
    //   if (maxPriceUrlParam && !isNaN(maxPriceUrlParam)) {
    //     const maxPrice = parseInt(maxPriceUrlParam, 10);
    //     if (minPriceUrlParam) {
    //       if (maxPrice > parseInt(minPriceUrlParam, 10)) {
    //         changeMaxPriceFilter(maxPrice);
    //         payload[MAX_PRICE_PARAM] = maxPrice;
    //       }
    //     } else {
    //       changeMaxPriceFilter(maxPrice);
    //       payload[MAX_PRICE_PARAM] = maxPrice;
    //     }
    //   }

    if (departDate && departDate.from && departDate.to) {
      changeTouristsSearchText(
        getTouristsText(adultsPayload, kidsNewState.length),
      );

      changeDatesSearchText(
        `${getDateText(departDate)} / ${getNightsText(
          parseInt(nightsFromPayload, 10),
          parseInt(nightsToPayload, 10),
        )}`,
      );
    }
  } else {
    window.location.replace(HOME_PAGE);
  }

  // eslint-disable-next-line consistent-return
  return payload;
}

export function getHotelsCountText(hotelsCount) {
  let result = '';

  let count = hotelsCount;
  if (count > 1000) {
    count %= 1000;
  }

  if (count > 100) {
    count %= 100;
  }

  if (count > 20) {
    count %= 10;
  }

  if (count === 0) {
    result = `Найдено ${hotelsCount} отелей`;
  } else if (count === 1) {
    result = `Найден ${hotelsCount} отель`;
  } else if (count < 5) {
    result = `Найдено ${hotelsCount} отеля`;
  } else {
    result = `Найдено ${hotelsCount} отелей`;
  }

  return result;
}

export function getInHotelsCountText(hotelsCount) {
  let result = '';

  let count = hotelsCount;
  if (count > 1000) {
    count %= 1000;
  }

  if (count > 100) {
    count %= 100;
  }

  if (count > 20) {
    count %= 10;
  }

  if (count === 0) {
    result = `в ${hotelsCount} отелях`;
  } else if (count === 1) {
    result = `в ${hotelsCount} отеле`;
  } else if (count < 5) {
    result = `в ${hotelsCount} отелях`;
  } else {
    result = `в ${hotelsCount} отелях`;
  }

  return result;
}

export function getToursCount(toursCount) {
  let result = '';

  let count = toursCount;
  if (count > 1000) {
    count %= 1000;
  }

  if (count > 100) {
    count %= 100;
  }

  if (count > 10 && count < 20) {
    count = 0;
  } else if (count > 10) {
    count %= 10;
  }

  if (count === 0) {
    result = `Найдено ${toursCount} туров`;
  } else if (count === 1) {
    result = `Найден ${toursCount} тур`;
  } else if (count < 5) {
    result = `Найдено ${toursCount} тура`;
  } else {
    result = `Найдено ${toursCount} туров`;
  }

  return result;
}

export function firstLetterInUpperCaseWithStars(hotel) {
  let splitStr = [];

  if (hotel.name && hotel.name.length > 0) {
    splitStr = hotel.name.toLowerCase().split(' ');
    for (let i = 0; i < splitStr.length; i++) {
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
  }

  let result = splitStr.join(' ');

  if (hotel.stars && hotel.stars > 0) {
    result += ` ${hotel.stars}*`;
  }
  return result;
}

export function firstLetterInUpperCase(str) {
  let splitStr = [];

  if (str && str.length > 0) {
    splitStr = str.toLowerCase().split(' ');
    for (let i = 0; i < splitStr.length; i++) {
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
  }

  return splitStr.join(' ');
}

export function getHotelLocationName(hotel) {
  let result = '';

  if (hotel.subregion && hotel.subregion.length > 0) {
    result += `${hotel.subregion}, `;
  }

  if (hotel.region && hotel.region.length > 0) {
    result += `${hotel.region}, `;
  }

  if (hotel.country && hotel.country.length > 0) {
    result += `${hotel.country}`;
  }

  return result;
}

export function getRatingColor(rating) {
  let result = '';
  if (rating <= 2) {
    result = 'tr_rating_red';
  } else if (rating <= 3.9) {
    result = 'tr_rating_yellow';
  } else {
    result = 'tr_rating_green';
  }

  return result;
}

export function getAgeText(age) {
  if (age === 0) {
    return '0 лет';
  } else if (age === 1) {
    return '1 год';
  } else if (age < 5) {
    return `${age} года`;
  }

  return `${age} лет`;
}

export function getWeekText(index) {
  let week;

  switch (index) {
    case 0:
      week = 'Вс.';
      break;
    case 1:
      week = 'Пн.';
      break;
    case 2:
      week = 'Вт.';
      break;
    case 3:
      week = 'Ср.';
      break;
    case 4:
      week = 'Чт.';
      break;
    case 5:
      week = 'Пт.';
      break;
    case 6:
      week = 'Суб.';
      break;
    default:
      break;
  }

  return week;
}

export function getDayMonthWeek(stringDate) {
  const date = moment(stringDate, 'DD.MM.YYYY').toDate();

  return `${date.getDate()} ${getMonth(date)} ${getWeekText(date.getDay())}`;
}

export function getDayMonth(stringDate) {
  const date = moment(stringDate, 'DD.MM.YYYY').toDate();

  return `${date.getDate()} ${getMonth(date)}`;
}

export function getHotsDayMonth(stringDate) {
  const date = moment(stringDate, 'YYYY-MM-DD').toDate();

  return `${date.getDate()} ${getMonth(date)}`;
}

export function getTouristsTextActualiz(acualizationData) {
  let result = '';
  const count =
    parseInt(acualizationData.adults, 10) +
    parseInt(acualizationData.child, 10);

  if (count === 1) {
    result = '1 турист';
  } else if (count < 5) {
    result = `${count} туриста`;
  } else {
    result = `${count} туристов`;
  }

  let childText = '';
  if (
    acualizationData.childage1 ||
    acualizationData.childage2 ||
    acualizationData.childage3
  ) {
    childText += ' (';

    if (acualizationData.childage1) {
      childText += `ребенок ${getAgeText(
        parseInt(acualizationData.childage1, 10),
      )}`;
    }

    if (acualizationData.childage2) {
      if (childText.length > 2) {
        childText += ', ';
      }

      childText += `ребенок ${getAgeText(
        parseInt(acualizationData.childage2, 10),
      )}`;
    }

    if (acualizationData.childage3) {
      if (childText.length > 2) {
        childText += ', ';
      }
      childText += `ребенок ${getAgeText(
        parseInt(acualizationData.childage3, 10),
      )}`;
    }

    childText += ')';
    result += childText;
  }

  return result;
}

export function getTouristsTextActualizOrder(order) {
  let result = '';
  const count = parseInt(order.adultsCount, 10) + parseInt(order.kidsCount, 10);

  if (count === 1) {
    result = '1 турист';
  } else if (count < 5) {
    result = `${count} туриста`;
  } else {
    result = `${count} туристов`;
  }

  let childText = '';
  if (order.childage1 || order.childage2 || order.childage3) {
    childText += ' (';

    if (order.childage1) {
      childText += `ребенок ${getAgeText(parseInt(order.childage1, 10))}`;
    }

    if (order.childage2) {
      if (childText.length > 2) {
        childText += ', ';
      }

      childText += `ребенок ${getAgeText(parseInt(order.childage2, 10))}`;
    }

    if (order.childage3) {
      if (childText.length > 2) {
        childText += ', ';
      }
      childText += `ребенок ${getAgeText(parseInt(order.childage3, 10))}`;
    }

    childText += ')';
    result += childText;
  }

  return result;
}

export function getCountry(countryName) {
  const countryArr = countries.filter((e) => e.name === countryName);

  if (countryArr.length > 0) {
    return countryArr[0];
  }

  return null;
}

export function getShortString(value, length) {
  if (value) {
    if (value.length <= length) {
      return value;
    } else {
      return `${value.substring(0, length - 3)}...`;
    }
  } else {
    return '';
  }
}

export function getMealText(meal) {
  let mealText = meal;
  const filteredMeal = meals.filter((e) => e.name === meal);

  if (filteredMeal.length === 1) {
    mealText = filteredMeal[0].russianfull;
  }

  return mealText;
}

export function formatHotelImageUrl(url) {
  if (url && url.length > 0) {
    return `https://${url.substring(2)}`;
  }

  return '';
}

export function getHotelStars(stars) {
  let result = '';
  if (stars && parseInt(stars, 10) > 0) {
    result = `${stars}*`;
  }

  return result;
}

export function buildOrderUrl(tourId) {
  const queryParameters = new URLSearchParams();
  queryParameters.append(TOUR_ID, tourId);

  return `/tour?${queryParameters.toString()}`;
}

export function formatPrice(price) {
  if (price) {
    return Math.ceil(price).toLocaleString('ru-RU');
  }

  return '0';
}

export function getToursCountFromSearch(hotels) {
  let resustl = 0;

  if (hotels && hotels.length > 0) {
    for (let i = 0; i < hotels.length; i++) {
      const tours = hotels[i].tours;

      if (tours) {
        resustl += tours.length;
      }
    }
  }

  return resustl;
}

// Parses html from external api (e.g. '<ul><li>a</li></ul>') into text items
export function getHtmlTextItems(html) {
  if (!html) {
    return [];
  }

  const doc = new DOMParser().parseFromString(html, 'text/html');
  const listItems = Array.from(doc.querySelectorAll('li'));
  const items =
    listItems.length > 0
      ? listItems.map((item) => item.textContent)
      : [doc.body.textContent];

  return items.map((item) => item.trim()).filter((item) => item.length > 0);
}

// Decodes html entities (e.g. '&#8203;') and removes zero-width chars
export function getPlainText(text) {
  if (!text) {
    return '';
  }

  const doc = new DOMParser().parseFromString(text, 'text/html');

  return doc.body.textContent.replace(/[\u200B-\u200D\uFEFF]/g, '');
}

// words: ['комната', 'комнаты', 'комнат']
export function getWordByQuantity(quantity, words) {
  const lastTwo = quantity % 100;
  const last = quantity % 10;
  let result;

  if (lastTwo >= 11 && lastTwo <= 14) {
    result = words[2];
  } else if (last === 1) {
    result = words[0];
  } else if (last >= 2 && last <= 4) {
    result = words[1];
  } else {
    result = words[2];
  }

  return result;
}

// Expiration time (ms) of the stored JWT, 0 if there is no valid token
export function getAccessTokenExpiration() {
  const token = window.localStorage.getItem('accessToken');

  if (!token) {
    return 0;
  }

  try {
    const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const { exp } = JSON.parse(window.atob(payload));
    return exp ? exp * 1000 : 0;
  } catch (e) {
    return 0;
  }
}

export function isAccessTokenValid() {
  return getAccessTokenExpiration() > Date.now();
}

export function clearUserSession() {
  window.localStorage.removeItem('accessToken');
  window.localStorage.removeItem('email');
  window.localStorage.setItem('isUserLoggedIn', false);
}
